import React from 'react';
import './PaymentPolicy.css';  // Import the CSS file
import Footer from '../Footer/Footer';
import NavBar from '../NavBar/NavBar';
import RunningHeader from '../RunningHeader/RunningHeader';

const PaymentPolicy = () => {
  return (
    <div>
      <NavBar/>
      <RunningHeader/>
    <div className="payment-policy">
      <h2>Payment Policy for Reporters</h2>
      

      <div className="payment-policy-content">
      <p>
        Today Local News ("TLN") is committed to providing fair and timely payment to its reporters ("Reporters") for their contributions to the TLN website.
      </p>
        <h3>1. Payment Terms</h3>
        <p><strong>1.1</strong> TLN shall pay Reporters for their contributions, including articles, images, and videos, in accordance with the payment rates outlined below.</p>
        <p><strong>1.2 Payment rates:</strong></p>
        <ul>
          <li>Articles: ₹ [RATE] per article</li>
          <li>Images: ₹ [RATE] per image (Depend on the Views)</li>
          <li>Videos: ₹ [RATE] per video</li>
          <li>Investigative reporting: ₹ [RATE] per article</li>
        </ul>
        <p><strong>1.3</strong> TLN reserves the right to adjust payment rates at any time, without notice or liability.</p>

        <h3>2. Payment Schedules</h3>
        <p><strong>2.1</strong> TLN shall make payments to Reporters on a [FREQUENCY] basis, e.g., weekly, bi-weekly, or monthly.</p>
        <p><strong>2.2</strong> Payments shall be made within [NUMBER] days of receipt of the Reporter's invoice.</p>

        <h3>3. Invoice Requirements</h3>
        <p><strong>3.1</strong> Reporters shall submit invoices to TLN on a [FREQUENCY] basis, e.g., weekly, bi-weekly, or monthly.</p>
        <p><strong>3.2</strong> Invoices shall include the following information:</p>
        <ul>
          <li>Reporter's name and address</li>
          <li>Date and description of work completed</li>
          <li>Payment rate and total amount due</li>
          <li>Invoice number and date</li>
        </ul>

        <h3>4. Payment Methods</h3>
        <p><strong>4.1</strong> TLN shall make payments to Reporters via [PAYMENT METHOD], e.g., bank transfer, UPI, or cheque.</p>
        <p><strong>4.2</strong> Reporters shall provide TLN with their preferred payment method and details.</p>

        <h3>5. Taxes and Deductions</h3>
        <p><strong>5.1</strong> TLN shall deduct applicable taxes and other deductions from payments made to Reporters.</p>
        <p><strong>5.2</strong> Reporters shall be responsible for their own tax obligations and shall provide TLN with any necessary tax documentation.</p>

        <h3>6. Dispute Resolution</h3>
        <p><strong>6.1</strong> Any disputes arising from payments or payment terms shall be resolved through mutual discussion and negotiation.</p>
        <p><strong>6.2</strong> If a dispute cannot be resolved through negotiation, it shall be referred to arbitration in accordance with the [ARBITRATION RULES].</p>

        <h3>7. Changes to Payment Policy</h3>
        <p><strong>7.1</strong> TLN reserves the right to modify or update this Payment Policy at any time, without notice or liability.</p>
        <p><strong>7.2</strong> Reporters shall be notified of any changes to the Payment Policy and shall be given the opportunity to terminate their agreement with TLN if they do not accept the changes.</p>

        <h3>8. Contact Us</h3>
        <p><strong>8.1</strong> If you have any questions or concerns about this Payment Policy, please contact TLN's finance department at:</p>
        <ul>
          <li>Email: [CONTACT EMAIL]</li>
          <li>Address: [CONTACT ADDRESS]</li>
          <li>Phone: [CONTACT PHONE NUMBER]</li>
        </ul>
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default PaymentPolicy;
